export const APP_LOAD = "APP_LOAD";
export const ASYNC_START = "ASYNC_START";
export const ASYNC_END = "ASYNC_END";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const USER_REGISTER = "USER_REGISTER";
export const HOME_PAGE_LOADED = "HOME_PAGE_LOADED";
export const HOME_PAGE_UNLOADED = "HOME_PAGE_UNLOADED";
export const UPDATE_FIELD_AUTH = "UPDATE_FIELD_AUTH";
export const UPDATE_FIELD_EDITOR = "UPDATE_FIELD_EDITOR";
export const LOGIN_PAGE_UNLOADED = "LOGIN_PAGE_UNLOADED";
export const REGISTER_PAGE_UNLOADED = "REGISTER_PAGE_UNLOADED";
export const REDIRECT = "REDIRECT";
export const ARTICLE_SUBMITTED = "ARTICLE_SUBMITTED";
export const SETTINGS_SAVED = "SETTINGS_SAVED";
export const REGISTER = "REGISTER";
export const DELETE_ARTICLE = "DELETE_ARTICLE";
export const ARTICLE_PAGE_UNLOADED = "ARTICLE_PAGE_UNLOADED";
export const EDITOR_PAGE_UNLOADED = "EDITOR_PAGE_UNLOADED";
export const PROFILE_PAGE_UNLOADED = "PROFILE_PAGE_UNLOADED";
export const PROFILE_FAVORITES_PAGE_UNLOADED =
  "PROFILE_FAVORITES_PAGE_UNLOADED";
export const SETTINGS_PAGE_UNLOADED = "SETTINGS_PAGE_UNLOADED";
export const USER_INVITE = "USER_INVITE";



// WEBPACK FOOTER //
// src/constants/actionTypes.js